<template>
  <a-modal
    :title="$t('title.supplyQuantityMaintain')"
    :centered="true"
    :visible="visible"
    width="40%"
    :destroyOnClose="destroyOnClose"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel">
    <a-spin :spinning="loading">
      <a-descriptions :column="1" bordered>
        <a-descriptions-item :label="$t('business.label.itemNo')">
          <span>{{ item.no }}</span>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('business.label.itemName')">
          <span>{{ item.name }}</span>
        </a-descriptions-item>
        <a-descriptions-item v-model="item.storers" :label="$t('business.label.storer')">
          <template #default="{ row }">{{ getStrings(row.storers, 'name') }}</template>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('business.label.supplyQuantity')">
          <a-input-number :min="0" style="width: 100%" v-model="item.numberOfSupply" />
        </a-descriptions-item>
      </a-descriptions>
    </a-spin>
  </a-modal>
</template>
<script>
  import { findOne, save } from '@/api/Api'
  import { Item } from '@/api/dto/common/Item'
  import { getStrings } from '@/utils/util'

  export default {
    name: 'SeedingItemMaintainModal',
    data() {
      return {
        visible: false,
        confirmLoading: false,
        destroyOnClose: true,
        item: new Item(),
        loading: false
      }
    },
    methods: {
      getStrings,
      open(itemId) {
        if (itemId) {
          this.visible = true
          if (itemId) {
            this.loading = true
            findOne('itemFactory', { id: itemId }).then(res => {
              if (res.success) {
                this.item = new Item(res.result)
              } else {
                this.confirmLoading = false
              }
            }).finally(() => this.loading = false)
          }
        }
      },
      handleOk() {
        this.confirmLoading = true
        const item = this.item.toJSONObject()
        save('itemPersister', item).then(res => {
          if (res.success) {
            this.item = new Item(res.result)
            this.$emit('success', this.item)
            let that = this
            this.$success({
              title: '保存成功',
              content: '将返回播种界面',
              onOk() {
                that.handleCancel()
              },
              okText: '确定',
              centered: true
            })
          }
        }).finally(() => this.confirmLoading = false)
      },
      handleCancel() {
        this.visible = false
      }
    }
  }
</script>